import {
  getMessaging,
  getToken,
  isSupported,
  Messaging,
} from 'firebase/messaging';
import { app } from '../../firebase';
import { VAPID_KEY } from 'library/constants/push';
import { storeDeviceToken } from './device';
import { getMessaging as getFgMessaging, onMessage } from 'firebase/messaging';

let messagingInstance: Messaging | null = null;

export const getMessagingInstance = async (): Promise<Messaging | null> => {
  try {
    if (!(await isSupported())) return null;
    if (!messagingInstance) messagingInstance = getMessaging(app);
    return messagingInstance;
  } catch {
    return null;
  }
};

export const initFcmAndGetToken = async (): Promise<string | null> => {
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    let swReg: ServiceWorkerRegistration | undefined = undefined;
    try {
      swReg =
        (await navigator.serviceWorker.getRegistration('/sw.js')) || undefined;
    } catch {}
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swReg,
    } as any);
    if (token) {
      storeDeviceToken(token);
      try {
        localStorage.setItem('fcmDeviceToken', token);
      } catch {}
    }
    return token || null;
  } catch {
    return null;
  }
};

// Listen for foreground messages and show a notification toast using the Notification API
export const attachForegroundMessageHandler = async (
  onForegroundMessage?: (payload: any) => void,
) => {
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) return;
    onMessage(messaging as any, (payload: any) => {
      try {
        if (onForegroundMessage) onForegroundMessage(payload);
        const data = (payload && (payload as any).data) || {};
        const title =
          data?.senderName || payload?.notification?.title || 'Unpaqd';
        const body = data?.message || payload?.notification?.body;
        if (document.hasFocus()) return; // avoid double-notifying while focused
        if (title || body) {
          new Notification(title, {
            body,
            icon: '/images/favicon_io/icon-192.png',
          });
        }
      } catch {}
    });
  } catch {}
};
